import { Legend as y } from "../component/Legend.js";
import { getMainColorOfGraphicItem as j } from "./ChartUtils.js";
import { findChildByType as w } from "./ReactUtils.js";
function u(r) {
  "@babel/helpers - typeof";
  return u = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, u(r);
}
function v(r, e) {
  var t = Object.keys(r);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(r);
    e && (n = n.filter(function(d) {
      return Object.getOwnPropertyDescriptor(r, d).enumerable;
    })), t.push.apply(t, n);
  }
  return t;
}
function p(r) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? v(Object(t), !0).forEach(function(n) {
      S(r, n, t[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(r, Object.getOwnPropertyDescriptors(t)) : v(Object(t)).forEach(function(n) {
      Object.defineProperty(r, n, Object.getOwnPropertyDescriptor(t, n));
    });
  }
  return r;
}
function S(r, e, t) {
  return e = D(e), e in r ? Object.defineProperty(r, e, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : r[e] = t, r;
}
function D(r) {
  var e = T(r, "string");
  return u(e) == "symbol" ? e : e + "";
}
function T(r, e) {
  if (u(r) != "object" || !r) return r;
  var t = r[Symbol.toPrimitive];
  if (t !== void 0) {
    var n = t.call(r, e);
    if (u(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(r);
}
var E = function(e) {
  var t = e.children, n = e.formattedGraphicalItems, d = e.legendWidth, P = e.legendContent, o = w(t, y);
  if (!o)
    return null;
  var g = y.defaultProps, b = g !== void 0 ? p(p({}, g), o.props) : {}, c;
  return o.props && o.props.payload ? c = o.props && o.props.payload : P === "children" ? c = (n || []).reduce(function(m, a) {
    var f = a.item, i = a.props, s = i.sectors || i.data || [];
    return m.concat(s.map(function(l) {
      return {
        type: o.props.iconType || f.props.legendType,
        value: l.name,
        color: l.fill,
        payload: l
      };
    }));
  }, []) : c = (n || []).map(function(m) {
    var a = m.item, f = a.type.defaultProps, i = f !== void 0 ? p(p({}, f), a.props) : {}, s = i.dataKey, l = i.name, h = i.legendType, O = i.hide;
    return {
      inactive: O,
      dataKey: s,
      type: b.iconType || h || "square",
      color: j(a),
      value: l || s,
      // @ts-expect-error property strokeDasharray is required in Payload but optional in props
      payload: i
    };
  }), p(p(p({}, b), y.getWithHeight(o, d)), {}, {
    payload: c,
    item: o
  });
};
export {
  E as getLegendProps
};
